import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import {
  getFormData,
  getFormUploads,
  getProcessInstances,
  updateFormField,
} from 'store/forms/actions';
import { TabsTimeline, FormFooter  } from 'components';
import { isNil } from 'lodash';
import { checkUser, checkUserLogged, getUser , getTaxisData} from 'store/user/actions';
import { getMainformDetails, kadBranchesService } from 'store/forms/actions';
import { stepsOC } from './stepsOC';
import { useSupplierType } from 'hooks/useSupplierType';
import { useNavigate } from 'react-router-dom';
import { isBeneficiary, isObjectionCommittee  } from '../../../utils';
import isEmpty from 'lodash/isEmpty';
import { Spin } from 'antd';

const MainFormsOC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();
  const [current, setCurrent] = useState(7);
  const currentSubTab = useSelector(state => state.forms.carrier.currentSubTab);
  const { isDirectSupplier, isIndirectSupplier } = useSupplierType()
  // const [requiredFieldsError, setRequiredFieldsError] = useState(true);
  const user = useSelector(state => state.user);
  const task = useSelector(state => state.forms.task);
  const viewMode = useSelector(state => state.forms.carrier.viewMode);
  const loadingPage = useSelector(state=>state.user.loading);
  const [loadingPageVar, setLoadingPageVar] = useState(true);
  const activeTaskName = useSelector(state => state.forms.activeTaskName);
  const currentDate = new Date().toISOString().split('T')[0];

  useEffect(() => {
    dispatch(getUser());
    dispatch(getTaxisData());
    dispatch(getFormData(params.taskId));
    dispatch(getFormUploads(params.taskId));
    if(window.location.pathname.includes('view')){
      dispatch(
        updateFormField({
          group: 'carrier',
          key: 'viewMode',
          value: true
           
        })
      );
    }
  }, [dispatch, params.taskId]);

  useEffect(() => {
  if(viewMode || (( activeTaskName && activeTaskName !== "task.name.application_submission"))){
    if(!isEmpty(task?.processInstanceId)){
      dispatch(getMainformDetails(task?.processInstanceId));
    }
  }
  }, [task?.processInstanceId, activeTaskName]);

  useEffect(()=>{
  if(!isNil(loadingPage)){
    setLoadingPageVar(loadingPage);
  }
  },[loadingPage]);

  useEffect(() => {
    dispatch(
      checkUserLogged(
        navigate,
        callback => {
          if(callback){
            dispatch(getUser());
          }
        }
      ),
    );
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
        dispatch(checkUser(navigate));
    }, process.env.REACT_APP_SESSION_CHECK_TIME);
    return () => clearInterval(intervalId);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Set current step based on user and Status
      useEffect(() => {
        if (!stepsOC) return;
    
        if (isObjectionCommittee(user?.groups)) {
          if (isIndirectSupplier && isDirectSupplier) setCurrent(8); // Άμεσος και Έμμεσος
          else if(isIndirectSupplier && !isDirectSupplier) setCurrent(5); // Έμμεσος
          else if(!isIndirectSupplier && isDirectSupplier) setCurrent(7); // Άμεσος
          else setCurrent(0);
        } else {
          setCurrent(0);
        }
      }, [user?.groups, isDirectSupplier, isIndirectSupplier, stepsOC]);
  

  return (
    loadingPageVar ?
    <div
      style={{
        position:"absolute",
        left:"50%",
        top:"50%"
      }}
    >
      <Spin size="large" />
    </div> 
    :
    <div id="mainforms-page-1" className="investor-form-container">
     {!isNil(current) && 
     <div className="investor-steps-footer-container">
      <TabsTimeline 
          tabs={stepsOC({ isDirectSupplier, isIndirectSupplier})}
          current={current} 
          setCurrent={setCurrent} 
          customClass={`custom-tabs-timeline active-tab-${current+1}`}
      />
      <FormFooter 
        tabs={stepsOC({ isDirectSupplier, isIndirectSupplier})}
        current={current} 
        setCurrent={setCurrent} 
        currentSubTab={currentSubTab} />
      </div>
      }
    </div>
  );
};

export default MainFormsOC;
